import DefaultApiService from "./default";

const MapGeocodingApiService = {
  getClientConfig: async () => {
    return DefaultApiService.getApi("Map/Geocoding/GetClientConfig");
  },

  search: async ({ term, lat, lng }) => {
    return DefaultApiService.getApi("Map/Geocoding/Search", { term, lat, lng });
  },

  reverseGeocode: async ({ lat, lng }) => {
    return DefaultApiService.getApi("Map/Geocoding/Reverse", { lat, lng });
  },
};

export default MapGeocodingApiService;
